import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

// Actions
import { getIncidentTypes } from "../state/incidentTypes/actions";

// Single call site for fetching incident types, mounted once from
// CasesRoutes.jsx (which itself never remounts while navigating between case
// sub-pages) - guarded by local state rather than a per-caller Redux-state
// check, so there's no race no matter how many components read the data via
// useIncidentTypes.
const useLoadIncidentTypes = () => {
  const [initialized, setInitialized] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!initialized) {
      dispatch(getIncidentTypes());
      setInitialized(true);
    }
  }, [dispatch, initialized]);
};

export default useLoadIncidentTypes;
